import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { booleanSchema } from 'src/Configuration/validation/rules'
import { FormInitializerReturnType } from 'src/Configuration/validation'
import { object } from 'yup'

interface ConfirmDeletionForm {
  confirmDeletion: boolean
}

/**
 * Initializes the form for deleting a user profile
 * @returns initialValues and validationSchema for user deletion form
 */
export const useDeleteProfileFormInitializer = (): FormInitializerReturnType<ConfirmDeletionForm, ConfirmDeletionForm> => {
  const { t } = useCustomTranslation()
  const booleanSchemaWithTranslation = booleanSchema(t)
  const initialValues = {
    confirmDeletion: false,
  }
  const validationSchema = object().shape({
    confirmDeletion: booleanSchemaWithTranslation({ hasToBeTrue: true }).required(),
  })
  return { initialValues, validationSchema }
}
